var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":"http://110.42.184.128:8090/img/1639557056903.png"},on:{"click":_vm.toGit}})}
var staticRenderFns = []

export { render, staticRenderFns }